let wares = [
    {
        path: 'wares',
        name: '商品管理',
        // redirect: 'wares/brand-application',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
            {
                path: 'release/:id?',
                component: () => import("@/views/sellerAdmin/marketing/wares/product-release/index.vue"),
                name: '商品发布',
                meta: {
                    hidden: true,
                    key:2001,
                },
            },
            {
                path: 'merchan-dising',
                component: () => import("@/views/sellerAdmin/marketing/wares/merchan-dising/index.vue"),
                name: '商品管理',
                meta: {
                    hidden: true,
                    key:2002,
                },
            },
            {
                path: 'categories',
                component: () => import("@/views/sellerAdmin/marketing/wares/categories/index.vue"),
                name: '分类管理',
                meta: {
                    hidden: true,
                    key:2003,
                },
            },
            {
                path: 'brand-application',
                component: () => import("@/views/sellerAdmin/marketing/wares/brand-application/index.vue"),
                name: '经营品牌申请',
                meta: {
                    hidden: true,
                    key:2004,
                },
            },
            {
                path: 'associated-layout',
                component: () => import("@/views/sellerAdmin/marketing/wares/associated-layout/index.vue"),
                name: '关联版式',
                meta: {
                    hidden: true,
                    key:2005,
                },
            },
            {
                path: 'evaluate',
                component: () => import("@/views/sellerAdmin/marketing/wares/evaluate/index.vue"),
                name: '评价管理',
                meta: {
                    hidden: true,
                    key:2007,
                },
            },
            {
                path: 'data-import',
                component: () => import("@/views/sellerAdmin/marketing/wares/data-import/index.vue"),
                name: '数据导入',
                meta: {
                    hidden: true,
                    key:2008,
                },
            },
        ]
    },

]


let community = [
    {
        path: 'community',
        name: '社区管理',
        // redirect: 'community/shop-super',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
            {
                path: 'shop-super',
                component: () => import("@/views/sellerAdmin/marketing/shop/shop-super/index.vue"),
                name: '店铺管理',
                meta: {
                    hidden: true,
                    key:4002,
                },
            },
            {
                path: 'salesroom-super',
                component: () => import("@/views/sellerAdmin/marketing/shop/salesroom-super/index.vue"),
                name: '门店管理',
                meta: {
                    hidden: true,
                    key:4008,
                },
            },
            {
                path: 'finance',
                component: () => import("@/views/sellerAdmin/marketing/shop/finance/index.vue"),
                name: '财务管理',
                meta: {
                    hidden: true,
                    key:4005,
                },
                redirect: 'finance/overview',
                children: [
                    {
                        path: 'overview',
                        component: () => import("@/views/sellerAdmin/marketing/shop/finance/overview/index.vue"),
                        name: '财务总览',
                        meta: {
                            hidden: true,
                        },
                    },
                    {
                        path: 'incomplete',
                        component: () => import("@/views/sellerAdmin/marketing/shop/finance/incomplete/index.vue"),
                        name: '待结算',
                        meta: {
                            hidden: true,
                        },
                    },
                    {
                        path: 'accomplish',
                        component: () => import("@/views/sellerAdmin/marketing/shop/finance/accomplish/index.vue"),
                        name: '已结算',
                        meta: {
                            hidden: true,
                        },
                    },
                    {
                        path: 'logs',
                        component: () => import("@/views/sellerAdmin/marketing/shop/finance/logs/index.vue"),
                        name: '收支明细',
                        meta: {
                            hidden: true,
                        },
                    },
                    {
                        path: 'withdrawal',
                        component: () => import("@/views/sellerAdmin/marketing/shop/finance/withdrawal/index.vue"),
                        name: '提现明细',
                        meta: {
                            hidden: true,
                        },
                    },
                ]
            },
        ]

    },
]

let trade = [
    {
        path: 'trade',
        name: '交易管理',
        // redirect: '/digit/trade/order',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
            {
                path: 'order',
                component: () => import("@/views/sellerAdmin/marketing/trade/order/index.vue"),
                name: '订单管理',
                meta: {
                    hidden: true,
                    key:3001,
                },
                redirect: 'order/list',
                children: [
                    {
                        path: 'list',
                        component: () => import("@/views/sellerAdmin/marketing/trade/order/default/index.vue"),
                        name: '订单列表',
                        meta: {
                            hidden: true,
                            parent: '/digit/trade/order'
                        },
                    },
                    // {
                    //     path: 'delivery/:id',
                    //     component: () => import("@/views/sellerAdmin/marketing/trade/order/delivery/index.vue"),
                    //     name: '订单发货',
                    //     meta: {
                    //         hidden: true,
                    //         parent: '/digit/trade/order'
                    //     },
                    // },
                    {
                        path: 'details/:id/:isEdit?',
                        component: () => import("@/views/sellerAdmin/marketing/trade/order/details/index.vue"),
                        name: '订单详情',
                        meta: {
                            hidden: true,
                            parent: '/digit/trade/order'
                        },
                    },

                ]
            },
            {
                path: 'refund',
                component: () => import("@/views/sellerAdmin/marketing/trade/refund-processing/index.vue"),
                name: '退款处理',
                meta: {
                    hidden: true,
                    key:3002,
                    url:"/digit/trade/order"
                },
            },
            {
                path: 'return',
                component: () => import("@/views/sellerAdmin/marketing/trade/return-processing/index.vue"),
                name: '退货处理',
                meta: {
                    hidden: true,
                    key:3003,
                    url:"/digit/trade/order"
                },
            },
            {
                path: 'complaint',
                component: () => import("@/views/sellerAdmin/marketing/trade/trade-complaint/index.vue"),
                name: '客诉管理',
                meta: {
                    hidden: true,
                    key:3004,
                },
            },
            {
                path: 'freight-template',
                component: () => import("@/views/sellerAdmin/marketing/trade/freight-template/index.vue"),
                name: '运费模板管理',
                meta: {
                    hidden: true,
                    key:3006,
                },
                redirect: 'freight-template/list',
                children: [
                    {
                        path: 'list',
                        component: () => import("@/views/sellerAdmin/marketing/trade/freight-template/list/index.vue"),
                        name: '管理',
                        meta: {
                            hidden: true,
                            current: "list"
                        },
                    },
                    {
                        path: 'multi/:id?',
                        component: () => import("@/views/sellerAdmin/marketing/trade/freight-template/multi/index.vue"),
                        name: '多功能',
                        meta: {
                            hidden: true,
                            current: "multi"
                        },
                    },
                ]
            },
            {
                path: 'address',
                component: () => import("@/views/sellerAdmin/marketing/trade/address/index.vue"),
                name: '发/退货地址',
                redirect: 'address/list',
                meta: {
                    hidden: true,
                    key:3008,
                },
                children: [
                    {
                        path: 'list',
                        component: () => import("@/views/sellerAdmin/marketing/trade/address/list/index.vue"),
                        name: '发/退货列表',
                        meta: {
                            hidden: true,
                            current: "list"
                        },
                    },
                    {
                        path: 'multi/:id?',
                        component: () => import("@/views/sellerAdmin/marketing/trade/address/multi/index.vue"),
                        name: '发/退货增编',
                        meta: {
                            hidden: true,
                            current: "multi"
                        },
                    },
                ]
            },
            {
                path: 'write-off',
                component: () => import("@/views/sellerAdmin/marketing/trade/write-off/index.vue"),
                name: '核销管理',
                meta: {
                    hidden: true,
                    key:3009,
                },
            },
        ]
    },
]



let census = [
    {
        path: 'census',
        name: '资产统计',
        // redirect: 'census/flow',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
            {
                path: 'flow',
                component: () => import("@/views/sellerAdmin/marketing/census/flow/index.vue"),
                name: '流量统计',
                meta: {
                    hidden: true,
                    key:5001,
                },
            },
            {
                path: 'shop',
                component: () => import("@/views/sellerAdmin/marketing/census/shop/index.vue"),
                name: '店铺统计',
                meta: {
                    hidden: true,
                    key:5002,
                },
            },
            {
                path: 'goods',
                component: () => import("@/views/sellerAdmin/marketing/census/goods/index.vue"),
                name: '商品统计',
                meta: {
                    hidden: true,
                    key:5003,
                },
            },
            {
                path: 'trade',
                component: () => import("@/views/sellerAdmin/marketing/census/trade/index.vue"),
                name: '交易统计',
                meta: {
                    hidden: true,
                    key:5004,
                },
            },
        ]
    },
]


let marketing = [
    {
        path: 'marketing',
        name: '营销管理',
        // redirect: 'marketing/coupon',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
            {
                path: 'coupon',
                component: () => import("@/views/sellerAdmin/marketing/marketing/coupon/index.vue"),
                name: '优惠卷',
                meta: {
                    hidden: true,
                    key:7002,
                },
                redirect: 'coupon/list',
                children: [
                    {
                        path: 'list',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/coupon/list/index.vue"),
                        name: '优惠卷活动列表',
                        meta: {
                            hidden: true,
                            current: "list",
                        },
                    },
                    {
                        path: 'multi/:id?',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/coupon/multi/index.vue"),
                        name: '优惠卷多功能',
                        meta: {
                            hidden: true,
                            current: "multi",
                        },
                    },
                    {
                        path: 'serve',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/coupon/serve/index.vue"),
                        name: '优惠卷购买服务',
                        meta: {
                            hidden: true,
                            current: "serve",
                        },
                    },
                    {
                        path: 'receiving-record/:id',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/coupon/receiving-record/index.vue"),
                        name: '领取记录',
                        meta: {
                            hidden: true,
                            parent: '/coupon'
                        },
                    },
                    {
                        path: 'detail/:id',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/coupon/detail/index.vue"),
                        name: '优惠卷详情',
                        meta: {
                            hidden: true,
                            parent: '/coupon'
                        },
                    },
                ]
            },
            {
                path: 'full-reduction',
                component: () => import("@/views/sellerAdmin/marketing/marketing/full-reduction/index.vue"),
                name: '满额减',
                redirect: 'full-reduction/list',
                meta: {
                    hidden: true,
                    key:7008,
                },
                children: [
                    {
                        path: 'list',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/full-reduction/list/index.vue"),
                        name: '满额减活动列表',
                        meta: {
                            hidden: true,
                            key: 'digital/marketing',
                            parent: '/full-reduction',
                            current: "list",
                        },
                    },
                    {
                        path: 'multi/:id?',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/full-reduction/multi/index.vue"),
                        name: '满额减多功能',
                        meta: {
                            hidden: true,
                            key: 'digital/marketing',
                            parent: '/full-reduction',
                            current: "multi",
                        },
                    },
                    {
                        path: 'serve',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/full-reduction/serve/index.vue"),
                        name: '满额减购买服务',
                        meta: {
                            hidden: true,
                            key: 'digital/marketing',
                            parent: '/full-reduction',
                            current: "serve",
                        },
                    },

                ]
            },
            {
                path: 'limit-buy',
                component: () => import("@/views/sellerAdmin/marketing/marketing/limit-buy/index.vue"),
                name: '限时购',
                redirect: 'limit-buy/list',
                meta: {
                    hidden: true,
                    key:7001,
                },
                children: [
                    {
                        path: 'list',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/limit-buy/list/index.vue"),
                        name: '限时购活动列表',
                        meta: {
                            hidden: true,
                            current: "list",
                        },
                    },
                    {
                        path: 'multi/:id?',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/limit-buy/multi/index.vue"),
                        name: '限时购多功能',
                        meta: {
                            hidden: true,
                            current: "multi",
                        },
                    },
                    {
                        path: 'serve',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/limit-buy/serve/index.vue"),
                        name: '购买服务',
                        meta: {
                            hidden: true,
                            current: "serve",
                        },
                    },

                ]
            },
            {
                path: 'collage',
                component: () => import("@/views/sellerAdmin/marketing/marketing/collage/index.vue"),
                name: '拼团',
                redirect: 'collage/list',
                meta: {
                    hidden: true,
                    key:7007,
                },
                children: [
                    {
                        path: 'list',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/collage/list/index.vue"),
                        name: '拼团活动列表',
                        meta: {
                            hidden: true,
                            current: "list",
                        },
                    },
                    {
                        path: 'multi/:id?',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/collage/multi/index.vue"),
                        name: '拼团多功能',
                        meta: {
                            hidden: true,
                            key: 'digital/marketing',
                            parent: '/collage',
                            current: "multi",
                        },
                    },
                    {
                        path: 'serve',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/collage/serve/index.vue"),
                        name: '拼团服务',
                        meta: {
                            hidden: true,
                            key: 'digital/marketing',
                            parent: '/collage',
                            current: "serve",
                        },
                    },
                    {
                        path: 'details/:id',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/collage/details/index.vue"),
                        name: '组团详情',
                        meta: {
                            hidden: true,
                            key: 'digital/marketing',
                            parent: '/collage'
                        },
                    },
                ]
            },
            // {
            //     path: 'group-buy',
            //     component: () => import("@/views/sellerAdmin/marketing/marketing/group-buy"),
            //     name: '组合购',
            //     meta: {
            //         hidden: true,
            //         key:7003,
            //     },
            // },
            {
                path: 'allowance-price',
                component: () => import("@/views/sellerAdmin/marketing/marketing/allowance-price/index.vue"),
                name: '代金红包',
                redirect: 'allowance-price/list',
                meta: {
                    hidden: true,
                    key:7006,
                },
                children: [
                    {
                        path: 'list',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/allowance-price/list/index.vue"),
                        name: '代金红包活动列表',
                        meta: {
                            hidden: true,
                            current: "list",
                        },
                    },
                    {
                        path: 'multi/:id?',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/allowance-price/multi/index.vue"),
                        name: '代金红包多功能',
                        meta: {
                            hidden: true,
                            current: "multi",
                        },
                    },
                    {
                        path: 'serve',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/allowance-price/serve/index.vue"),
                        name: '代金红包购买服务',
                        meta: {
                            hidden: true,
                            current: "serve",
                        },
                    },
                    {
                        path: 'details/:id',
                        component: () => import("@/views/sellerAdmin/marketing/marketing/allowance-price//details/index.vue"),
                        name: '代金红包领取详情',
                        meta: {
                            hidden: true,
                        },
                    }
                ]
            },
            {
                path: 'freightsetting',
                component: () => import("@/views/sellerAdmin/marketing/marketing/freightsetting"),
                name: '满额免运费',
                meta: {
                    hidden: true,
                    key:7005,
                },
            },
            {
                path: 'gift',
                component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/gift/index.vue"),
                name: '礼品管理',
                meta: {
                    hidden: true,
                    key:7009
                },
            },
            {
                path: 'gift-convert',
                component: () => import("@/views/admin/marketing/marketing/CBMC-sydney/gift-convert/index.vue"),
                name: '礼品兑换列表',
                meta: {
                    hidden: true,
                    key:7010
                },
            },
        ]
    },

]

export const digit = [
    {
        path: '/digit',
        name: '营销系统',
        redirect: '/digit/wares',
        component: () => import("@/views/layout/index.vue"),
        children: [
            ...wares,//商品
            ...community,//社区
            ...marketing,//营销
            ...trade,//交易
            ...census,//资产统计
        ]
    },

]
